import {
  DynamicZoneComponentDTO,
  StrapiDynamicZoneComponentDTO,
} from "@lib/strapi/dtos/core/dynamicZoneComponent.dto";
import {
  StrapiTeamSectionDTO,
  TeamSectionDTO,
} from "@lib/strapi/dtos/components/sections/teamSection.dto";
import { parseStrapiContent } from "@lib/strapi/content";

export class TeamSectionService {
  static async fromStrapi(
    locale: string,
    strapiData?: StrapiTeamSectionDTO,
  ): Promise<TeamSectionDTO> {
    if (!strapiData) {
      return null;
    }
    const dto = new TeamSectionDTO();
    Object.assign(
      dto,
      await DynamicZoneComponentDTO.fromStrapi(locale, strapiData),
    );
    dto.heading = strapiData.heading;
    dto.intro = await parseStrapiContent(strapiData.intro);
    dto.layout = strapiData.layout;
    dto.showBio = strapiData.showBio;
    return dto;
  }
}
